import {
    GraduationCap,
    Briefcase,
    Rocket,
    Handshake,
    Star,
    FlaskConical,
    ArrowUpRight,
} from "lucide-react";

const Services = () => {
    const services = [
        {
            Icon: GraduationCap,
            title: "AI & Tech Training",
            description:
                "Deep-dive programs in AI, ML, cloud, and modern development practices for enterprise teams.",
        },
        {
            Icon: Briefcase,
            title: "Talent Placement",
            description:
                "We match verified, deployment-ready AI professionals with organizations that need them.",
        },
        {
            Icon: Rocket,
            title: "Tech Internships",
            description:
                "Real-world AI internships built to launch the next generation of engineers.",
        },
        {
            Icon: Handshake,
            title: "Strategic Partnerships",
            description:
                "Co-build AI solutions, expand market reach, and drive shared transformation.",
        },
        {
            Icon: Star,
            title: "APS Training Academy",
            description:
                "As main sponsor of a 501(c)(3), we fund FREE STEAM education in underserved communities.",
            highlight: true,
            link: "https://www.apstrainingacademy.org",
        },
        {
            Icon: FlaskConical,
            title: "AI Research",
            description:
                "Cutting-edge research and PoC development for emerging AI capabilities.",
        },
    ];

    return (
        <section id="services" className="relative py-32 border-t border-white/5 bg-ink-900/40">
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
                    <div>
                        <div className="text-[11px] font-mono uppercase tracking-widest text-accent-brand mb-4">
                            / Services
                        </div>
                        <h2 className="text-5xl md:text-6xl lg:text-7xl font-display leading-[0.95] tracking-tight text-white max-w-3xl">
                            Beyond the platform,
                            <br />
                            <em className="italic text-white/50">we invest in</em>
                            <br />
                            the ecosystem.
                        </h2>
                    </div>
                    <p className="text-white/60 max-w-sm text-[15px] leading-relaxed">
                        Training, talent, partnerships, and community impact — because software alone doesn&apos;t move the world.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 rounded-2xl overflow-hidden border border-white/10">
                    {services.map((s, i) => {
                        const CardWrap = s.link ? "a" : "div";
                        const wrapProps = s.link
                            ? { href: s.link, target: "_blank", rel: "noopener noreferrer" }
                            : {};
                        return (
                            <CardWrap
                                key={i}
                                {...wrapProps}
                                className={`group block bg-ink-950 hover:bg-ink-900 p-8 md:p-10 transition-all duration-300 relative ${
                                    s.highlight ? "ring-1 ring-accent-brand/40" : ""
                                }`}
                                data-testid={`service-card-${i}`}
                            >
                                {s.highlight && (
                                    <div className="absolute top-4 right-4 text-[10px] font-mono uppercase tracking-widest px-2 py-1 rounded-full bg-accent-brand text-ink-950">
                                        Featured
                                    </div>
                                )}
                                <div className="w-11 h-11 rounded-lg bg-white/[0.04] border border-white/10 flex items-center justify-center mb-6 group-hover:bg-accent-brand group-hover:border-accent-brand transition-all">
                                    <s.Icon
                                        className="w-5 h-5 text-white/70 group-hover:text-ink-950 transition-colors"
                                        strokeWidth={1.5}
                                    />
                                </div>
                                <h3 className="text-2xl font-display text-white mb-3 tracking-tight">
                                    {s.title}
                                </h3>
                                <p className="text-white/50 text-[14px] leading-relaxed mb-6">
                                    {s.description}
                                </p>
                                {s.link && (
                                    <div className="flex items-center gap-2 text-accent-brand text-[12px] font-mono uppercase tracking-widest">
                                        Visit Academy
                                        <ArrowUpRight className="w-3.5 h-3.5" />
                                    </div>
                                )}
                            </CardWrap>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Services;
